<template>
	<div class="model-item" v-if="!empty" :class="{ hide : !showStatus, fail: status === 'failed' }">
		<template v-if="status !== 'failed'">
			<div class="model-list-item__prefix" :class="loadingStatus">
				<xl-tooltip v-if="!loadingStatus || loadingStatus === 'success'" :content="showStatus ? $t('button.hide') : $t('button.check')" placement="top" :offset="14">
					<i class="toggle-show iconfont eye" :class="`icon-${showStatus ? 'a-yincangmoxingbeifen2' : 'yincangmoxingbeifen'}`"  @click="emit('updateShowStatus', !showStatus)"></i>
				</xl-tooltip>
				<xl-progress v-if="loadingStatus === 'loading'" class="process-icon" type="circle" :percentage="percentage" :width="27"/>
				<xl-tooltip v-if="loadingStatus === 'error'" :content="$txdo('modelData.modelLoad.text')" placement="top" :offset="12">
					<img class="loading-error" src="../../assets/image/loading-error.svg" alt="" @click="emit('reloadModel')"/>
				</xl-tooltip>
			</div>
			<modelIcon class="model-list-item__icon" :resultType="resultType" :modelTips="attachTip" :type="detailType" :toothNum="toothNum"  :classType="classType"></modelIcon>
			<xl-slider class="model-list-item__op model-op" :disabled="!showStatus" :format-tooltip="(e) => `${e}%`" v-model="op" @mousedown="emit('updateSliderDragState', true)" @mouseup="emit('updateSliderDragState', false)" @change="opChange"></xl-slider>
		</template>
		<template v-else>
			<div class="model-list-item__prefix">
				<i class="iconfont icon-yichangwenjian" ></i>
			</div>
			<modelIcon :modelTips="attachTip" :resultType="resultType" :type="detailType" :toothNum="toothNum" :classType="classType" ></modelIcon>
			<span class="model-list-item__text">{{ $txdo('design.modelData.buildFailure') }}</span>
		</template>
	</div>
	<div v-else class="model-item empty" >
		<div class="model-list-item__prefix">
			<i class="iconfont icon-yichangwenjian" ></i>
		</div>
		<span class="model-list-item__text">{{ $txdo('design.modelData.noData') }}</span>
	</div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { XlTooltip, XlSlider, XlProgress } from '@shining3d/ui-components';
import modelIcon from './modelIcon.vue';

import { useLang } from '@shining3d/common-module/utils/lang';
const { $t } = useLang( '@shining3d/app' );
const { $t: $txdo } = useLang( '@shining3d/xl-design-order' );

const props = defineProps({
	loadingStatus: String,
	showStatus: { type: Boolean },
    percentage: [String, Number],
	status: String,
	detailType: String,
	toothNum: [Number, String],
	progress: Number,
	errorCode: {
		type: String,
		default: 'fail error'
	},
	attachType: String,
	classType: String,
	attachTip: String,
	empty: {
		type: Boolean,
		default: false
	},
	resultType: String
});

const emit = defineEmits(['updateShowStatus', 'updateSliderDragState', 'update:progress', 'reloadModel']);

const op = ref( 100 ); // 模型透明度
watch(() => props.progress, ( val ) => {
	op.value = val;
}, { immediate: true });

const opChange = ( val ) => {
	emit( 'update:progress', val );
};
</script>
<style lang="scss" scoped>
.model-item {
	box-sizing: border-box;
	height: 40px;
	border-radius: 3px;
	background: #F7F8FA;
	padding: 3px 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	&.hide {
		.toggle-show, :deep(.model-icon){
			opacity: 0.6;
		}
	}
	.model-list-item__prefix {
		font-size: 20px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		margin-right: 12px;
		height: 28px;
		width: 28px;
		cursor: pointer;
		.iconfont {
			font-size: 20px;
		}
		.loading-error {
			font-size: 20px;
		}
		.process-icon {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		:deep(.el-progress-circle) {
			height: 16px !important;
			width: 16px !important;
			margin: 0 14px;
		}
		&:hover {
			background: #E9EBEF;
    		border-radius: 4px;
		}
	}
	.model-list-item__op {
		flex: 1;
		margin-left: 22px;
		:deep(.el-slider__button) {
			width: 16px;
			height: 16px;
			border: 3px solid #42526E;
		}
	}
	.model-list-item__text {
		flex: 1;
		margin-left: 22px;
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
		display: inline-block;
		width: 0;
		overflow: hidden;
	}
	&.fail {
		color: #E64C4C;
		.model-list-item__prefix {
			cursor: unset;
			&:hover {
				background: unset;
			}
		}
	}
	&.empty {
		color: #A5ACBE;
		.model-list-item__prefix {
			cursor: unset;
			&:hover {
				background: unset;
			}
		}
		.model-list-item__text {
			margin-left: 0;
		}
	}
}
.model-item + .model-item  {
	margin-top: 8px;
}
</style>
